import { render, staticRenderFns } from "./Longevity.vue?vue&type=template&id=b8637700&scoped=true&"
import script from "./Longevity.vue?vue&type=script&lang=js&"
export * from "./Longevity.vue?vue&type=script&lang=js&"
import style0 from "./Longevity.vue?vue&type=style&index=0&id=b8637700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8637700",
  null
  
)

export default component.exports